import axiosTokenInstance from '../../../services/api/backoffice';

import { INCIDENCE_CHANNEL, INCIDENCE_CHANNEL_ERROR } from '_models/redux/types';

// Action function
export const getIncidenceChannel = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/catalogs/support-tickets-channels`);

    const { data } = response || {};

    dispatch({
      type: INCIDENCE_CHANNEL,
      payload: data || {},
    });
  } catch (e) {
    dispatch({
      type: INCIDENCE_CHANNEL_ERROR,
      payload: e || {},
    });
  }
};
